<template>
  <i-container class="_align-self:stretch _padding:0" am-admin-users fluid>
    <div class="_display:flex" am-table-cell>
      <div am-th-cell>Name</div>
      <div am-th-cell="email">Email</div>
      <div am-th-cell>Role</div>
      <div am-th-cell>Created at</div>
      <div am-th-cell>Actions</div>
    </div>
    <div am-table>
      <div v-for="user in users" :key="user.id" class="_display:flex" >
        <div am-cell>{{user.name}}</div>
        <div am-cell="email">{{user.email}}</div>
        <div am-cell>{{user.role}}</div>
        <div am-cell>{{dateConvert(user.created_at)}}</div>
        <div am-cell>
          <i-button
            color="primary"
            style="width: 100px;"
            class="_margin-right:1/2 _margin-bottom:1/4"
            @click="editUser(user)"
          >
            Edit
          </i-button>
          <i-button
            @click="deleteUser(user)"
            style="width: 100px;"
            class="_margin-bottom:1/4"
          >
            Delete
          </i-button>
        </div>
      </div>
      <i-card v-if="isNeedPagination">
        <i-pagination
          v-if="isNeedPagination"
          v-model="page"
          :items-total="totalCount"
          :items-per-page="page_size" />
      </i-card>
    </div>
    <div v-if="confirmDelete">
      <i-modal v-model="confirmDelete">
        <template #header>
          Delete user: {{ isDeleteData.name }}?
        </template>
        <div am-deleted-buttons>
          <i-button @click="notRemoved">
            No
          </i-button>
          <i-button color="primary" @click="removed">
            Yes
          </i-button>
        </div>
      </i-modal>
    </div>
    <div v-if="isEditUser">
      <i-modal v-model="isEditUser">
        <template #header>
          Edit user
        </template>
        <edit-user
          :user="userEditable"
          @changed="changed"
        />
      </i-modal>
    </div>
  </i-container>
</template>

<script>
import { mapMutations } from 'vuex'
import editUser from '@/components/admin/editUser'

export default {
  name: 'AdminUsers',
  data: () => ({
    users: null,
    confirmDelete: false,
    isDeleteData: null,
    page: 1,
    totalCount: null,
    page_size: 20,
    isEditUser: false,
    userEditable: null
  }),
  components: {
    editUser
  },
  mounted () {
    this.getUsers()
  },
  computed: {
    isNeedPagination () {
      if ((this.totalCount / this.page_size) > 1) {
        return true
      } else return false
    }
  },
  watch: {
    page (val) {
      this.$router.push({
        query: {
          page: val,
          page_size: this.page_size
        }
      })
    }
  },
  beforeMount () {
    this.$watch(
      () => this.$route.params,
      () => {
        if (this.$route.query.page) {
          this.page = Number(this.$route.query.page)
        } else this.page = 1
        if (this.$route.query.page_size) {
          this.page_size = Number(this.$route.query.page_size)
        } else this.page_size = 20
        this.getUsers()
      },
      { immediate: true }
    )
    if (!this.$store.state.allRoles) {
      this.$store.dispatch('getRoles')
    }
  },
  methods: {
    ...mapMutations('notifications', ['addNotification']),
    changed () {
      this.isEditUser = false
      this.userEditable = null
      this.getUsers()
    },
    async getUsers () {
      const data = await this.$store.dispatch('getUsers', {
        page: this.page,
        page_size: this.page_size
      })
      this.users = data.users
      this.totalCount = Number(data.totalCount)
    },
    dateConvert (publicationDate) {
      const date = new Date(publicationDate)
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
      return date.toLocaleString('en', options)
    },
    editUser (user) {
      this.userEditable = { ...user }
      this.isEditUser = true
    },
    deleteUser (user) {
      this.isDeleteData = {
        id: user.id,
        name: user.name
      }
      this.confirmDelete = true
    },
    notRemoved () {
      this.confirmDelete = false
      this.isDeleteData = {}
    },
    async removed () {
      const isDelete = await this.$store.dispatch('deleteUser', this.isDeleteData.id)
      this.confirmDelete = false
      this.isDeleteData = {}
      if (isDelete) {
        this.getUsers()
      }
    }
  }
}
</script>

<style lang="scss">
[am-admin-users] {
  ----font-size: 0.85rem;
  ----line-height: 1.2;
  ----spacing: 0.25rem;
  ----padding: #{var(----spacing)};

  font-size: var(----font-size);
  [am-table-cell], [am-table] {
    width: 100%;
    [am-cell], [am-th-cell] {
      width: calc(100% / 5);
    }
    [am-cell~='email'], [am-th-cell~='email'] {
      min-width: 300px;
    }
  }
  [am-table] {
    overflow: auto;
    height: calc(100vh - 100px);
  }
  [am-deleted-buttons] {
    display: flex;
    justify-content: space-between;
    button {
      width: calc(50% - 5px);
    }
  }
}
</style>
